// 把員工清單整理成 react-select 的分組 options
import { partTimeJobIds } from '../../const/constant';

// 與 StaffList 的分店對應一致
const STORE_NAMES = {
  1: '總店',
  2: '海大店',
  3: '北大店',
};

// 職務名稱沿用 ShiftSheet 的命名慣例：內場正職、外場兼職、吧檯正職…
const DEPARTMENTS = [
  { label: '內場', keyword: '內場' },
  { label: '外場', keyword: '外場' },
  { label: '吧檯', keyword: '吧檯' },
  { label: '其他', keyword: null },
];

// 多店員工在各分店的職務不同，以當前分店為準
function getStaffJob(staff) {
  const storeName = STORE_NAMES[localStorage.getItem('current_store_id')];
  const jobs = Array.isArray(staff.jobs) ? staff.jobs : [];
  const job = jobs.filter((item) => item.storeName === storeName)[0];
  if (job) return { name: job.jobName || '', id: job.jobId };
  return { name: staff.jobType || '', id: staff.jobTypeId };
}

function getDepartmentLabel(jobName) {
  const department = DEPARTMENTS.filter((item) => item.keyword && jobName.indexOf(item.keyword) !== -1)[0];
  return department ? department.label : '其他';
}

export function buildStaffOptions(staffList = []) {
  // allStaffListInAdjustState 的初始值是一筆 id 為 0 的佔位資料
  const employed = staffList.filter((staff) => staff && staff.id > 0 && staff.status === 1 && staff.realName);

  const grouped = employed.map((staff) => {
    const job = getStaffJob(staff);
    return {
      department: getDepartmentLabel(job.name),
      isPartTime: partTimeJobIds.indexOf(job.id) !== -1,
      option: { value: staff.id, label: staff.realName },
    };
  });

  return DEPARTMENTS.map((department) => {
    const members = grouped.filter((item) => item.department === department.label);
    return {
      label: department.label,
      // 正職排在兼職之前，同類維持原本的清單順序
      options: members
        .filter((item) => !item.isPartTime)
        .concat(members.filter((item) => item.isPartTime))
        .map((item) => item.option),
    };
  }).filter((group) => group.options.length > 0);
}
